import React, {useCallback} from 'react';
import {useTranslation} from "react-i18next";
import {CpRuleSchema} from "../../../../../../api/DBSchema/CPRule";
import actionBlockLogo from '../../../../../../assets/images/action_block.png';
import actionAcceptLogo from '../../../../../../assets/images/action_accept.png';
import logLevelAccountLogo from '../../../../../../assets/images/log_level_account.png';
import logLevelAlertLogo from '../../../../../../assets/images/log_level_alert.png';
import logLevelLogLogo from '../../../../../../assets/images/log_level_log.png';
import logLevelNoneLogo from '../../../../../../assets/images/log_level_none.png';
import appControlIcon from '../../../../../../assets/images/app_control_16.png';
import RowLayout from '../../../../../../components/Layouts/RowLayout';
import appCategoryIcon from '../../../../../../assets/images/app_category.png';
import anyIcon from '../../../../../../assets/images/any.svg';
import applicationIcon from '../../../../../../assets/images/application.svg';
import icmpIcon from '../../../../../../assets/images/icmp_connection.svg';
import internetIcon from '../../../../../../assets/images/internet.svg';
import domainIcon from '../../../../../../assets/images/domain.svg';
import customAppIcon from '../../../../../../assets/images/custom_application.svg';
import networkSingleIpIcon from '../../../../../../assets/images/network_single_ip_24.svg';
import networkIpRangeIcon from '../../../../../../assets/images/network_ip_range_24.svg';
import networkIpIcon from '../../../../../../assets/images/network.svg';
import networkIpv6SingleIcon from '../../../../../../assets/images/network_single_ipv6_24.svg';
import networkIpv6RangeIcon from '../../../../../../assets/images/network_ipv6_range_24.svg';
import networkIpv6Icon from '../../../../../../assets/images/network_ipv6_24.svg';
import zoneIcon from '../../../../../../assets/images/zone.svg';
import otherServicesIcon from '../../../../../../assets/images/other_services.svg';
import serviceTCPIcon from '../../../../../../assets/images/service_tcp_24.svg';
import serviceUDPIcon from '../../../../../../assets/images/service_udp_24.svg';
import {getUpdatableObjectImageById} from '../../../../../../utils/utils';


const appiImages = require.context('../../../../../../assets/images/appi', true);

export const ACCESS_POLICY_INCOMING = "incoming";
export const ACCESS_POLICY_OUTGOING = "outgoing";

export const useAccessPolicyUtils = (appiData, zonesData, uoTableData) => {

    const {t} = useTranslation();

    const getUoNameByCode = useCallback((updatableObjectCode) => {
        if (uoTableData && updatableObjectCode) {
            const uoObj = searchFunction(uoTableData, updatableObjectCode)
            if (!uoObj) {
                return "";
            }
            return <RowLayout spacing="4px" wrap="nowrap"><img width="16px"
                                                               src={getUpdatableObjectImageById(uoObj.icon)} alt=""
                                                               style={{
                                                                   paddingRight: '6px',
                                                                   width: '24px',
                                                                   height: '12px'
                                                               }}/>{uoObj.displayName}</RowLayout>;
        }
        return "";
    }, [uoTableData]);

    const getZoneNameByCode = useCallback((zoneCode) => {
        if (zonesData && zoneCode) {
            const zoneObj = zonesData.find(obj => (obj.zoneCode === zoneCode))
            if (!zoneObj) {
                return "";
            }
            return t(zoneObj.zoneName);
        }
        return "";
    }, [t, zonesData]);

    const getNetworkObjectString = useCallback(networkObject => {
        switch (networkObject[CpRuleSchema.sourceDestinationSchema.type]) {
            case 'ANY':
                return <RowLayout spacing="4px" wrap="nowrap"><img width="20px" src={anyIcon} alt="" style={{
                    paddingRight: '6px',
                    width: '100%',
                    height: '100%'
                }}/>
                    {t('SMP.PLAN.SEC_SOFT_BLADES.ANY')}</RowLayout>;
            case 'HOST': // single ip address
                return <RowLayout spacing="4px" wrap="nowrap"><img width="20px" src={networkSingleIpIcon} alt=""
                                                                   style={{
                                                                       paddingRight: '6px',
                                                                       width: '80%',
                                                                       height: '80%'
                                                                   }}/>
                    {networkObject[CpRuleSchema.sourceDestinationSchema.ipSingle]}</RowLayout>;
            case 'DOMAIN':
                return <RowLayout spacing="4px" wrap="nowrap"><img width="20px" src={domainIcon} alt="" style={{
                    paddingRight: '6px',
                    width: '100%',
                    height: '100%'
                }}/>
                    {networkObject[CpRuleSchema.sourceDestinationSchema.domain]}</RowLayout>;
            case 'UPDATABLE_OBJECTS':
                if (uoTableData.length === 0) {
                    return <RowLayout spacing="4px" wrap="nowrap"><img width="16px"
                                                                       src={getUpdatableObjectImageById(networkObject.updatableObjectIcon)}
                                                                       alt="" style={{
                        paddingRight: '6px',
                        width: '24px',
                        height: '12px'
                    }}/>{networkObject.updatableObjectName}</RowLayout>;
                }
                return getUoNameByCode(networkObject[CpRuleSchema.sourceDestinationSchema.updatableObjectCode]);
            case 'IP_RANGE':
                return <RowLayout spacing="4px" wrap="nowrap"><img width="20px" src={networkIpRangeIcon} alt="" style={{
                    paddingRight: '6px',
                    width: '80%',
                    height: '80%'
                }}/>
                    {networkObject[CpRuleSchema.sourceDestinationSchema.ipStart] + '-' + networkObject[CpRuleSchema.sourceDestinationSchema.ipEnd]}
                </RowLayout>;
            case 'INTERNET':
                return <RowLayout spacing="4px" wrap="nowrap"><img width="20px" src={internetIcon} alt=""
                                                                   style={{paddingRight: '6px'}}/>
                    {t('SMC_GATEWAYNET_INTERNET')}</RowLayout>;
            case 'NETWORK':
                return <RowLayout spacing="4px" wrap="nowrap"><img width="20px" src={networkIpIcon} alt="" style={{
                    paddingRight: '6px',
                    width: '100%',
                    height: '100%'
                }}/>
                    {networkObject[CpRuleSchema.sourceDestinationSchema.ipNetwork] + '/' + networkObject[CpRuleSchema.sourceDestinationSchema.ipMask]}
                </RowLayout>;
            case 'IPV6_HOST':
                return <RowLayout spacing="4px" wrap="nowrap"><img width="20px" src={networkIpv6SingleIcon} alt=""
                                                                   style={{
                                                                       paddingRight: '6px',
                                                                       width: '80%',
                                                                       height: '80%'
                                                                   }}/>
                    {networkObject[CpRuleSchema.sourceDestinationSchema.ipV6ObjectName]}</RowLayout>;
            case 'IPV6_RANGE':
                return <RowLayout spacing="4px" wrap="nowrap"><img width="20px" src={networkIpv6RangeIcon} alt=""
                                                                   style={{
                                                                       paddingRight: '6px',
                                                                       width: '80%',
                                                                       height: '80%'
                                                                   }}/>
                    {networkObject[CpRuleSchema.sourceDestinationSchema.ipV6ObjectName]}</RowLayout>;
            case 'IPV6_NETWORK':
                return <RowLayout spacing="4px" wrap="nowrap"><img width="20px" src={networkIpv6Icon} alt="" style={{
                    paddingRight: '6px',
                    width: '80%',
                    height: '80%'
                }}/>
                    {networkObject[CpRuleSchema.sourceDestinationSchema.ipV6ObjectName]}</RowLayout>;
            case 'ZONE':
                return <RowLayout spacing="4px" wrap="nowrap"><img width="20px" src={zoneIcon} alt="" style={{
                    paddingRight: '6px',
                    width: '100%',
                    height: '100%'
                }}/>
                    {getZoneNameByCode(networkObject[CpRuleSchema.sourceDestinationSchema.zone])}</RowLayout>;
            default:
                return null;
        }
    }, [t, getUoNameByCode, getZoneNameByCode, uoTableData]);

    const getNetworkObjectTitle = useCallback(networkObject => {
        switch (networkObject[CpRuleSchema.sourceDestinationSchema.type]) {
            case 'IPV6_HOST':
                return networkObject[CpRuleSchema.sourceDestinationSchema.ipV6Single];
            case 'IPV6_RANGE':
                return networkObject[CpRuleSchema.sourceDestinationSchema.ipV6Start] + '-' + networkObject[CpRuleSchema.sourceDestinationSchema.ipV6End];
            case 'IPV6_NETWORK':
                return networkObject[CpRuleSchema.sourceDestinationSchema.ipV6Network] + '/' + networkObject[CpRuleSchema.sourceDestinationSchema.ipV6Prefix];
            default:
                return "";
        }
    }, []);

    function getAppiImageById(id) {
        if (id.startsWith('cat_')) {
            return appCategoryIcon;
        } else if (id.startsWith('app_')) {
            const iconId = id.substr('app_'.length); // All appi ids start with app_, we only need the id number
            let imageSrc = '';
            try {
                // Try reading the image from appi image context, if it's not there, an exception will be thrown
                imageSrc = appiImages(`./${iconId}_sml.png`).default;
            } catch (e) {
                // If image not found from appi image context, use this url source
                imageSrc = 'https://sc1.checkpoint.com/za/images/facetime/small_png/' + iconId + "_sml.png";
            }
            return imageSrc;
        } else {
            return null;
        }
    }

    // If the image is not found, change the icon to appControlIcon (default appi image)
    function appiImageErrorHandler(e) {
        e.target.onerror = null;
        e.target.src = appControlIcon;
    }

    const getApplicationName = useCallback((applicationPredefinedAppId) => {
        let appName = applicationPredefinedAppId;
        if (appiData && applicationPredefinedAppId) {
            const obj = appiData.find((obj) => obj.id === applicationPredefinedAppId);
            if (obj) {
                appName = obj.name;
            }
        }
        return <RowLayout spacing="4px" wrap="nowrap"><img src={getAppiImageById(applicationPredefinedAppId)}
                                                           onError={appiImageErrorHandler} alt=""/>{appName}
        </RowLayout>;
    }, [appiData]);


    const getServiceString = useCallback(serviceObject => {
        var serviceType = serviceObject[CpRuleSchema.serviceSchema.type];
        if (serviceType === 'CUSTOM') {
            const customServiceType = serviceObject[CpRuleSchema.serviceSchema.customType];

            if (customServiceType === 'TCP' || customServiceType === 'UDP') {
                return customServiceType + ':' + serviceObject[CpRuleSchema.serviceSchema.ports];
            } else if (customServiceType === 'ICMP') {
                return customServiceType + ':' + serviceObject[CpRuleSchema.serviceSchema.icmpType] + '.' + serviceObject[CpRuleSchema.serviceSchema.icmpType];
            } else if (customServiceType === 'OTHER') {
                return t('SMP.PLAN.SEC_SOFT_BLADES.OTHER') + ':' + serviceObject[CpRuleSchema.serviceSchema.ipProtocol];
            }
        } else {
            switch (serviceType) {
                case 'ANY':
                    return t('SMP.PLAN.SEC_SOFT_BLADES.ANY');
                case 'ANY_TCP':
                    return 'Any_TCP';
                case 'ANY_UDP':
                    return 'Any_UDP';
                case 'MAIL':
                    return 'Mail';
                case 'NETBIOS':
                    return 'NetBios';
                case 'WEB_BROWSING':
                    return 'Web Browsing';
                case 'ANY_TCP_UDP':
                    return 'TCP/UDP';
                case 'DELAY_SENSITIVE_SERVICES':
                    return 'Delay_Sensitive_Services';
                case 'GUARANTEED_BANDWIDTH_SERVICES':
                    return 'Guaranteed_Bandwidth_Services';
                case 'VOIP':
                    return 'VoIP';
                default :
                    return serviceType;
            }
        }
    }, [t]);

    const getPredefinedApplication = useCallback(applicationObject => {
        return <RowLayout spacing="4px" wrap="nowrap"><img
            src={getAppiImageById(applicationObject[CpRuleSchema.applicationSchema.predefinedAppId])}
            onError={appiImageErrorHandler} alt=""/>{applicationObject.applicationName}</RowLayout>;
    },[]);

    const getApplicationString = useCallback(applicationObject => {
        const applicationType = applicationObject[CpRuleSchema.applicationSchema.type];

        if (applicationType === 'CUSTOM_URL') {
            return applicationObject[CpRuleSchema.applicationSchema.customUrlName];
        } else if (applicationType === 'PREDEFINED') {
            return appiData.length === 0 ? getPredefinedApplication(applicationObject) : getApplicationName(applicationObject[CpRuleSchema.applicationSchema.predefinedAppId]);
        } else if (applicationType === 'ANY') {
            return t('SMP.PLAN.SEC_SOFT_BLADES.ANY');
        } else {
            return applicationType;
        }

    }, [getApplicationName, t, appiData,getPredefinedApplication]);

    const getApplicationTitle = useCallback(applicationObject => {
        const applicationType = applicationObject[CpRuleSchema.applicationSchema.type];

        if (applicationType === 'CUSTOM_URL') {
            return applicationObject[CpRuleSchema.applicationSchema.customUrlValue];
        } else {
            return "";
        }

    }, []);

    const getServiceOrApplicationTitle = useCallback(ruleObject => {

        if (ruleObject[CpRuleSchema.serviceOrApplication] === 'APPI')
            return getApplicationTitle(ruleObject[CpRuleSchema.application]);
        else //service
            return "";

    }, [getApplicationTitle]);


    const getServiceOrApplicationString = useCallback(ruleObject => {
        if (ruleObject[CpRuleSchema.serviceOrApplication] === 'APPI') {
            const applicationObj = ruleObject[CpRuleSchema.application];
            const applicationType = applicationObj[CpRuleSchema.applicationSchema.type];
            switch (applicationType) {
                case 'ANY':
                    return <RowLayout spacing="4px" wrap="nowrap"><img width="20px" src={anyIcon} alt="" style={{
                        paddingRight: '6px',
                        width: '100%',
                        height: '100%'
                    }}/>
                        {getApplicationString(ruleObject[CpRuleSchema.application])}</RowLayout>;
                case 'CUSTOM_URL':
                    return <RowLayout spacing="4px" wrap="nowrap"><img width="20px" src={customAppIcon} alt="" style={{
                        paddingRight: '6px',
                        width: '100%',
                        height: '100%'
                    }}/>
                        {getApplicationString(ruleObject[CpRuleSchema.application])}</RowLayout>;
                default:
                    return getApplicationString(ruleObject[CpRuleSchema.application]);
            }
        } else {//service {
            const serviceObj = ruleObject[CpRuleSchema.service];
            //'toUpperCase' In order the icons will be the same before the save and after the save
            var serviceType = serviceObj[CpRuleSchema.serviceSchema.type].toUpperCase();
            switch (serviceType) {
                case 'ANY':
                case 'ANY_TCP_UDP':
                    return <RowLayout spacing="4px" wrap="nowrap"><img width="20px" src={anyIcon} alt="" style={{
                        paddingRight: '6px',
                        width: '100%',
                        height: '100%'
                    }}/>
                        {getServiceString(ruleObject[CpRuleSchema.service])}</RowLayout>;
                //TCP services
                case 'ANY_TCP':
                case 'HTTP':
                case 'HTTPS':
                case 'FTP':
                case 'SSH':
                case 'TELNET':
                case 'POP3':
                case 'IMAP':
                case 'SMTP':
                case 'CIFS':
                case 'DNS_TCP':
                case 'LDAP':
                case 'SIP_TCP':
                    return <RowLayout spacing="4px" wrap="nowrap"><img width="20px" src={serviceTCPIcon} alt="" style={{
                        paddingRight: '6px',
                        width: '80%',
                        height: '80%'
                    }}/>
                        {getServiceString(ruleObject[CpRuleSchema.service])}</RowLayout>;
                //UDP services
                case 'ANY_UDP':
                case 'SNMP':
                case 'TFTP':
                case 'DHCP':
                case 'DNS_UDP':
                case 'SIP_UDP':
                    return <RowLayout spacing="4px" wrap="nowrap"><img width="20px" src={serviceUDPIcon} alt="" style={{
                        paddingRight: '6px',
                        width: '80%',
                        height: '80%'
                    }}/>
                        {getServiceString(ruleObject[CpRuleSchema.service])}</RowLayout>;
                //application services
                case 'MAIL':
                case 'NETBIOS':
                case 'WEB_BROWSING':
                case 'DELAY_SENSITIVE_SERVICES':
                case 'GUARANTEED_BANDWIDTH_SERVICES':
                case 'VOIP':
                case 'DNS':
                case 'SIP':
                    return <RowLayout spacing="4px" wrap="nowrap"><img width="20px" src={applicationIcon} alt=""
                                                                       style={{paddingRight: '6px'}}/>
                        {getServiceString(ruleObject[CpRuleSchema.service])}</RowLayout>;
                //castom service types
                case 'CUSTOM':
                    const customServiceType = serviceObj[CpRuleSchema.serviceSchema.customType];
                    if (customServiceType === 'TCP') {
                        return <RowLayout spacing="4px" wrap="nowrap"><img width="20px" src={serviceTCPIcon} alt=""
                                                                           style={{
                                                                               paddingRight: '6px',
                                                                               width: '80%',
                                                                               height: '80%'
                                                                           }}/>
                            {getServiceString(ruleObject[CpRuleSchema.service])}</RowLayout>;
                    } else if (customServiceType === 'UDP') {
                        return <RowLayout spacing="4px" wrap="nowrap"><img width="20px" src={serviceUDPIcon} alt=""
                                                                           style={{
                                                                               paddingRight: '6px',
                                                                               width: '80%',
                                                                               height: '80%'
                                                                           }}/>
                            {getServiceString(ruleObject[CpRuleSchema.service])}</RowLayout>;
                    } else if (customServiceType === 'ICMP') {
                        return <RowLayout spacing="4px" wrap="nowrap"><img width="20px" src={icmpIcon} alt="" style={{
                            paddingRight: '6px',
                            width: '100%',
                            height: '100%'
                        }}/>
                            {getServiceString(ruleObject[CpRuleSchema.service])}</RowLayout>;
                    } else if (customServiceType === 'OTHER') {
                        return <RowLayout spacing="4px" wrap="nowrap"><img width="20px" src={otherServicesIcon} alt=""
                                                                           style={{
                                                                               paddingRight: '6px',
                                                                               width: '100%',
                                                                               height: '100%'
                                                                           }}/>
                            {getServiceString(ruleObject[CpRuleSchema.service])}</RowLayout>;
                    }
                    break;
                //Other services
                case 'ICMP':
                default:
                    return <RowLayout spacing="4px" wrap="nowrap"><img width="20px" src={otherServicesIcon} alt=""
                                                                       style={{
                                                                           paddingRight: '6px',
                                                                           width: '100%',
                                                                           height: '100%'
                                                                       }}/>
                        {getServiceString(ruleObject[CpRuleSchema.service])}</RowLayout>;
            }
        }

    }, [getApplicationString, getServiceString]);

    const getActionString = useCallback(action => {
        if (action === 'ACCEPT') {
            return t('SMP.PLAN.SEC_SOFT_BLADES.ACCEPT');
        } else {
            return t('SMP.PLAN.SEC_SOFT_BLADES.BLOCK');
        }
    }, [t]);

    const getActionIcon = useCallback(action => {
        if (action === 'ACCEPT') {
            return actionAcceptLogo;
        } else {
            return actionBlockLogo;
        }
    }, []);

    const getLogString = useCallback(log => {
        if (log === 'NONE') {
            return t('SMC_GEN_NONE');
        } else if (log === 'LOG') {
            return t('SMP.PLAN.SEC_SOFT_BLADES.LOG');
        } else if (log === 'ALERT') {
            return t('SMP.ALERT');
        } else if (log === 'ACCOUNT') {
            return t('SMP.PLAN.SEC_SOFT_BLADES.ACCOUNT');
        }
    }, [t]);

    const getLogIcon = useCallback(log => {
        if (log === 'NONE') {
            return logLevelNoneLogo;
        } else if (log === 'LOG') {
            return logLevelLogLogo;
        } else if (log === 'ALERT') {
            return logLevelAlertLogo;
        } else if (log === 'ACCOUNT') {
            return logLevelAccountLogo;
        }
    }, []);

    return {
        getNetworkObjectString,
        getServiceOrApplicationString,
        getActionString,
        getActionIcon,
        getLogString,
        getLogIcon,
        getServiceOrApplicationTitle,
        getNetworkObjectTitle
    }
}

//Go`s through the data tree to find the relevant object
// eslint-disable-next-line react-hooks/exhaustive-deps
export function searchFunction(uoTableData, updatableObjectCode) {
    let result;
    for (let i = 0; i < uoTableData.length; i++) {
        result = uoTableData.find(data => (data.objCodeName === updatableObjectCode));
        if (result) {
            return result;
        } else if (result === undefined) {
            result = searchFunction(uoTableData[i].children, updatableObjectCode);
            if (result) return result;
        }
    }
    return null;
}
